import React from "react";

const Hero = () => {
  return (
    <section id="hero" className="text-center py-20 md:py-32">
      <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight">
        Elite QA Automation <br />
        <span className="text-gradient">Driven by Innovation</span>
      </h1>
      <p className="mt-4 md:mt-6 text-xl text-gray-400 max-w-3xl mx-auto">
        Accelerate your testing maturity with AI-powered automation frameworks,
        strategic quality consulting, and scalable solutions for startups and
        mid-size engineering teams.
      </p>

      {/* Key Value Propositions */}
      <div className="mt-12 grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <div className="p-6 bg-gray-900/50 rounded-lg border border-gray-700/50">
          <div className="text-3xl mb-3">🚀</div>
          <h3 className="text-lg font-semibold text-white mb-2">
            AI-Powered Automation
          </h3>
          <p className="text-gray-400 text-sm">
            Advanced QA agent that generates Page Object Models and
            comprehensive test suites, accelerating framework development by 70%
          </p>
        </div>
        <div className="p-6 bg-gray-900/50 rounded-lg border border-gray-700/50">
          <div className="text-3xl mb-3">⚡</div>
          <h3 className="text-lg font-semibold text-white mb-2">
            Rapid Implementation
          </h3>
          <p className="text-gray-400 text-sm">
            Complete automation framework setup with TypeScript, Playwright,
            Java, and CI/CD integration in weeks, not months
          </p>
        </div>
        <div className="p-6 bg-gray-900/50 rounded-lg border border-gray-700/50">
          <div className="text-3xl mb-3">📈</div>
          <h3 className="text-lg font-semibold text-white mb-2">
            Strategic Mentoring
          </h3>
          <p className="text-gray-400 text-sm">
            Expert guidance on test strategy, quality metrics, and sustainable
            automation practices for long-term success
          </p>
        </div>
      </div>

      <div className="mt-8 md:mt-10 flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
        <a
          href="#services"
          className="px-8 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition w-full sm:w-auto text-center"
        >
          View Our Services
        </a>
        <a
          href="#technology"
          className="px-8 py-3 bg-gray-800 text-white font-medium rounded-lg hover:bg-gray-700 transition w-full sm:w-auto text-center"
        >
          Technology Stack
        </a>
      </div>
    </section>
  );
};

export default Hero;
